import PropTypes from 'prop-types';
import classNames from 'classnames';

var camelToKebab = function camelToKebab(camel) {
  return camel.replace(/[A-Z]/g, function (cap) {
    return "-".concat(cap.toLowerCase());
  });
};

var flexboxHelperPropTypes = {
  flexDirection: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  flexWrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  justifyContent: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-around', 'space-between', 'space-evenly', 'start', 'end', 'left', 'right']),
  alignContent: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-around', 'space-between', 'space-evenly', 'stretch', 'start', 'end', 'baseline']),
  alignItems: PropTypes.oneOf(['auto', 'flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  flexGrow: PropTypes.oneOf([0, 1, 2, 3, 4, 5])
};
var flexboxHelperNames = Object.keys(flexboxHelperPropTypes);
export default {
  propTypes: flexboxHelperPropTypes,
  defaultProps: flexboxHelperNames.reduce(function (defaults, flexboxHelperName) {
    defaults[flexboxHelperName] = undefined;
    return defaults;
  }, {}),
  classnames: function classnames(props) {
    return classNames(flexboxHelperNames.reduce(function (classes, flexboxHelper) {
      var propValue = props[flexboxHelper];
      classes["is-".concat(camelToKebab(flexboxHelper), "-").concat(propValue)] = propValue;
      return classes;
    }, {}));
  },
  clean: function clean(props) {
    return Object.keys(props).reduce(function (cleanedProps, propName) {
      if (!flexboxHelperNames.includes(propName)) {
        cleanedProps[propName] = props[propName];
      }

      return cleanedProps;
    }, {});
  }
};